import Encrypt from 'jsencrypt'

const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAteKD7ml+NGMKBuTThe07
GXgSu1xvDo/SbTslaEAV0xPbTZkbgoIPjQOMBQ5nbxS760BKfQ80g4125B6sOUw0
JS4vDhi0lAHMfHVpdywC+VoqhpugV2KI3wYQ11tHR3IESdqkacpgGCx4VC8km3Ys
Mlre+KAacQzI6IXffaTWTrVekT458wvFZIDO8VZ8xm6ldWHRcLrm/jAHwk/1upD8
NNciQ7JRXpGSK35JnaH2xnvCa/KcG6zMdjRHMfu8+HfnVxEmhoVR4q1RoVDj48in
1ngWT6FoSIJ71x3qQ9GgMX1RsdZFTNcEds2InMifHIZ8oCxXSstW303J09y2tLhv
2wIDAQAB
-----END PUBLIC KEY-----`

/* 加密 */
export function passwordEncrypt (data) {
  if (!data) {
    return data
  }
  const encrypt = new Encrypt()
  encrypt.setPublicKey(publicKey)
  const result = encrypt.encrypt(data)
  return result
}
